import {createFeatureSelector, createSelector} from "@ngrx/store";
import {ReportsState} from "./reports.reducer";

const ReportsSelectors = createFeatureSelector<ReportsState>('ss-cord.reports');

export const GetAllReportsOptions = createSelector(ReportsSelectors, (state) => state.reportOptions)

export const GetClinicsList = createSelector(ReportsSelectors, (state) => state.clinic)

export const GetGroupsList = createSelector(ReportsSelectors, (state) => state.group)

export const GetBehaviorType = createSelector(ReportsSelectors, (state) => state.behaviorType)

export const GetParticipantData = createSelector(ReportsSelectors, (state) => state.participant)

export const GetQuestionnairesData = createSelector(ReportsSelectors, (state) => state.questionnaire)

export const Reports = createSelector(ReportsSelectors, (state) => state.reports)

export const GetGeneratedReportsList = createSelector(ReportsSelectors, state=>state.reportList)

export const GetPollingReports = createSelector(ReportsSelectors, state=>state.pollingReports)

